module.exports = __webpack_public_path__ + "70ed5e1250a8236e04adb6ef93e37b5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/tradition.svg
// module id = 9
// module chunks = 0